export default __webpack_public_path__ + "static/media/post-image2.b2dd7e53.jpg";